import { useState } from 'react';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import { Container } from 'Components/Container';
import { DefaultTable } from 'Components/DefaultTable';
import { ModalConfirmDelete } from 'Components/ModalConfirmDelete';
import { PageLoaderList } from 'Components/PageLoader/List';
import { tableHeader } from './table-header.js';
import { getGapAnalysisReport, deleteGapAnalysisReport } from 'services/gap-analysis.js';
import { useAuthTenant } from 'store/auth';
import { useSelector } from 'react-redux';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import { NoData } from 'Components/NoData/index.jsx';
import { PageHelper } from 'Components/PageHelper';

const GapAnalysisReports = () => {
  const { t } = useTranslation(['dashboard', 'common']);
  const selectedTenant = useSelector(useAuthTenant);
  const SwalReact = withReactContent(Swal);
  const [open, setOpen] = useState(false);
  const [reFetch, setRefetch] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  const {
    isLoading,
    error,
    data: reportData,
  } = useQuery(['getGapAnalysisReport', selectedTenant._id, reFetch], async () => {
    if (!selectedTenant._id) return { data: [] };
    const result = await getGapAnalysisReport(selectedTenant._id);
    return result.data;
  });


  const onDelete = item => {
    setItemToDelete(item);
    setOpen(true);
  };


  const onClose = () => {
    setItemToDelete(null);
    setOpen(false);
  };

  const onConfirm = async () => {
    try {
      const result = await deleteGapAnalysisReport(itemToDelete?._id);
      if (result.status === 204 || result.status === 200) {
        onClose();
        setRefetch(!reFetch);
      } else {
        throw new Error(t('dashboard:gapAnalysis.error'));
      }
    } catch (error) {
      SwalReact.fire({
        title: t('dashboard:alert.errorTitle'),
        text: error?.response?.data?.message ?? error.message,
        icon: 'error',
      });
    }
  };
  console.log(reportData);
  return (
    <Container
      title={t('dashboard:gapAnalysis.title')}
      breadcrumb={t('dashboard:gapAnalysis.breadcrumb')}
      showButtonAdd
      data-tour="page-title"
      addButtonDataTour="add-button"
    >
      {isLoading && <PageLoaderList />}
      {error && <div>{t('dashboard:gapAnalysis.error')}</div>}
      {!isLoading && !error && reportData?.length === 0 && (
        <NoData description={t('dashboard:gapAnalysis.noData')} />
      )}
      {!isLoading && !error && reportData?.length > 0 && (
        <div className="container">
          <div data-tour="table">
            <DefaultTable
              rows={tableHeader(t)}
              cells={reportData}
              onClickDelete={onDelete}
              hideEdit
              link="reports/gap-analysis"
            />
          </div>
          {/* Paginação real pode ser feita depois no backend */}
          <ModalConfirmDelete
            description={t('dashboard:gapAnalysis.delete.confirm', { name: itemToDelete?.name })}
            open={open}
            onClose={onClose}
            onConfirm={onConfirm}
          />
        </div>
      )}
      <PageHelper steps={tourSteps} tourKey="reports-gap-analysis" />
    </Container>
  );
};

const tourSteps = [
  {
    target: 'body',
    content: 'Bem-vindo aos Relatórios de Gap Analysis! Aqui você visualiza todos os relatórios de análise de lacunas de conformidade gerados.',
    disableBeacon: true,
    disableScrolling: true,
    placement: 'center',
  },
  {
    target: '[data-tour="page-title"]',
    content: 'Clique no título para voltar à página anterior.',
    disableScrolling: true,
  },
  {
    target: '[data-tour="add-button"]',
    content: 'Use o botão "Adicionar" para gerar um novo relatório de Gap Analysis e avaliar a conformidade da sua organização.',
    disableScrolling: true,
  },
  {
    target: '[data-tour="table"]',
    content: 'Esta tabela lista todos os relatórios de Gap Analysis. Clique em um relatório para visualizar detalhes completos do dashboard de análise.',
    disableScrolling: false,
  },
  {
    target: 'body',
    content: 'Tour concluído! Gere relatórios de Gap Analysis regularmente para monitorar o progresso da conformidade da sua organização.',
    disableScrolling: true,
    placement: 'center',
  },
];

export default GapAnalysisReports;
